'use client';
import React, { useEffect, useState } from 'react';
import DownloadPopup from './download-popup';
import { BlogNewsProp } from '@/services';
import usePostView from '@/hooks/usePostView';

const POPUP_STORAGE_KEY = 'popup_shown_status';

function ScrollWrapper({
  children,
  post,
}: {
  children: React.ReactNode;
  post: BlogNewsProp | null;
}) {
  const [isOpen, setIsOpen] = useState(false);

  usePostView(post?.databaseId);

  useEffect(() => {
    if (post?.popupEnable && post?.slug) {
      const currentTime = new Date().getTime();
      const storedData = localStorage.getItem(POPUP_STORAGE_KEY);
      let popupStatus = storedData ? JSON.parse(storedData) : {};

      let shouldShowPopup = true;

      if (popupStatus[post.slug]) {
        const timestamp = popupStatus[post.slug];
        const oneHour = 60 * 60 * 1000; // 1시간을 밀리초로 표현
        if (currentTime - timestamp < oneHour) {
          shouldShowPopup = false;
        }
      }

      if (shouldShowPopup) {
        let frameId = 0;
        let isFrameQueued = false;

        const check = () => {
          isFrameQueued = false;

          const scrollTop =
            window.scrollY || document.documentElement.scrollTop;
          const windowHeight = window.innerHeight;
          const documentHeight = document.documentElement.scrollHeight;

          if (scrollTop + windowHeight >= documentHeight / 2) {
            setIsOpen(true);

            // 현재 페이지의 팝업 상태 업데이트
            popupStatus[post.slug] = currentTime;
            localStorage.setItem(
              POPUP_STORAGE_KEY,
              JSON.stringify(popupStatus),
            );

            window.removeEventListener('scroll', handleScroll);
          }
        };

        // scrollHeight 읽기는 강제 리플로우를 부르므로 스크롤 이벤트마다 하지 않고
        // 프레임당 한 번으로 묶는다. passive 는 컴포지터에서 스크롤이 계속 돌게 한다
        const handleScroll = () => {
          if (isFrameQueued) return;
          isFrameQueued = true;
          frameId = requestAnimationFrame(check);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
          window.removeEventListener('scroll', handleScroll);
          cancelAnimationFrame(frameId);
        };
      }
    }
  }, [post?.popupEnable, post?.slug]);

  return (
    <div>
      {children}
      <DownloadPopup isOpen={isOpen} setIsOpen={setIsOpen} post={post} />
    </div>
  );
}

export default ScrollWrapper;
